import React from "react";
import AxiosConfig from "axiosConfig";
import * as CONSTANT from "constants/text";
import "./ManageChildTribe.css";
import ProfilePic from "components/General/ProfilePic";
import TextTheme from "components/General/Text/TextTheme";
import "components/Spotlight/Spotlight_Common.css";
import FriendListContainer from "components/Tribe/Friends/FriendsHome/FriendListContainer";
import GroupListContainer from "components/Tribe/Groups/GroupsHome/GroupListContainer";
import { Fragment } from "react";

class ManageChildrenRequests extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      childrenGroupRequestList: [],
      childrenGroupInviteList: [],
      //will contain the info of each child.
      childrenFriendRequestList: [],
    };
  }

  componentDidMount() {
    //make all AXIOS calls needed.
    this.fetchChildrenFriendRequestList(this);
    this.fetchChildrenGroupRequestList(this);
    this.fetchChildrenGroupInviteList(this);
  }

  fetchChildrenFriendRequestList(obj) {
    AxiosConfig.get("friends/child/friend_requests/").then(function (response) {
      obj.setChildrenFriendRequestList(response);
    });
  }

  setChildrenFriendRequestList(response) {
    let childList = response.data;
    this.setState((prevState) => ({
      childrenFriendRequestList: childList,
    }));
  }

  fetchChildrenGroupRequestList(obj) {
    AxiosConfig.get("groups/requests/child-requests/").then(function (
      response
    ) {
      obj.setChildrenGroupRequestList(response);
    });
  }

  setChildrenGroupRequestList(response) {
    let groupList = response.data;
    this.setState((prevState) => ({
      childrenGroupRequestList: groupList,
    }));
  }

  fetchChildrenGroupInviteList(obj) {
    AxiosConfig.get("groups/invitations/child-invites/").then(function (
      response
    ) {
      obj.setChildrenGroupInviteList(response);
    });
  }

  setChildrenGroupInviteList(response) {
    let groupList = response.data;
    this.setState((prevState) => ({
      childrenGroupInviteList: groupList,
    }));
  }

  //refered to info found at  https://javascript.info/ for manipulating JSON, arrays and sorting
  renderFriendRequestList(
    receivedRequestList,
    sentRequestList,
    child_username
  ) {
    //combine and sort list by date when the friend request was made
    let allFriendRequests = [];
    //loop through received list and push each item onto the main list
    for (let i = 0; i < receivedRequestList.length; i++) {
      allFriendRequests.push(receivedRequestList[i]);
    }
    //loop through sent list and push each item onto the main list
    for (let j = 0; j < sentRequestList.length; j++) {
      allFriendRequests.push(sentRequestList[j]);
    }

    //sort by date, placing the most recent friend request first
    const sortedByDate = allFriendRequests.sort(function (a, b) {
      var dateA = a.created_at;
      var dateB = b.created_at;

      if (dateA < dateB) {
        return 1;
      }
      if (dateA > dateB) {
        return -1;
      }
      return 0;
    });

    return (
      <div>
        <FriendListContainer
          friendLists={sortedByDate}
          type={CONSTANT.CHILD_FRIEND_REQUESTS}
          child_username={child_username}
        />
      </div>
    );
  }
  renderGroupRequestList(receivedRequestList, sentRequestList, child_username) {
    //combine and sort list by date when the friend request was made
    let allGroupRequests = [];
    //loop through received list and push each item onto the main list
    for (let i = 0; i < receivedRequestList.length; i++) {
      if (receivedRequestList[i].user.username === child_username) {
        allGroupRequests.push(receivedRequestList[i]);
        receivedRequestList[i].type = CONSTANT.CHILD_GROUP_INVITATIONS;
      }
    }
    // loop through sent list and push each item onto the main list
    for (let j = 0; j < sentRequestList.length; j++) {
      if (sentRequestList[j].requester.username === child_username) {
        allGroupRequests.push(sentRequestList[j]);
        sentRequestList[j].type = CONSTANT.CHILD_GROUP_REQUEST;
      }
    }

    return (
      <GroupListContainer
        groupLists={allGroupRequests}
        child_username={child_username}
        type={CONSTANT.CHILD_GROUP_REQUEST}
        history={this.props.history}
        pageSize={6}
      />
    );
  }
  render() {
    return (
      <Fragment>
        {this.state.childrenFriendRequestList
          ? this.state.childrenFriendRequestList.map((elem, index) => (
              <div className="page_details_content_main mb-15">
                <div
                  className="list_header_info_column"
                  style={{ textAlign: "left" }}
                >
                  <div className="child_profile_pic">
                    <ProfilePic profilePic={elem.profile_pic} />
                  </div>
                  <TextTheme
                    message={elem.full_name}
                    className="text_medium text_bold text_dark_blue"
                  />
                </div>

                <div className="mt-15 request_title mb-15">
                  <TextTheme
                    message={CONSTANT.FRIEND_REQUESTS}
                    className="text_black text_medium text_semi_bold text_dark_blue"
                  />
                </div>
                {elem.requests_received.length !== 0 ||
                elem.requests_sent.length !== 0 ? (
                  this.renderFriendRequestList(
                    elem.requests_received,
                    elem.requests_sent,
                    elem.username
                  )
                ) : (
                  <TextTheme
                    message={CONSTANT.NO_NEW_FRIEND_REQUESTS}
                    className="mt-15 mb-15 text_small text_med_grey text-center"
                  />
                )}

                <div className="hr_vertical"> </div>

                <div className="mt-15 request_title mb-15">
                  <TextTheme
                    message={CONSTANT.GROUP_REQUESTS}
                    className="text_black text_medium text_semi_bold text_dark_blue"
                  />
                </div>
                <div style={{ textAlign: "left" }}>
                  {this.state.childrenGroupInviteList.length !== 0 ||
                  this.state.childrenGroupRequestList.length !== 0 ? (
                    this.renderGroupRequestList(
                      this.state.childrenGroupInviteList,
                      this.state.childrenGroupRequestList,
                      elem.username
                    )
                  ) : (
                    <TextTheme
                      message={CONSTANT.NO_NEW_GROUP_REQUESTS_INVITATIONS}
                      className="mt-15 text_small text_med_grey text-center"
                    />
                  )}
                </div>
              </div>
            ))
          : null}
      </Fragment>
    );
  }
}

export default ManageChildrenRequests;
